import { render, staticRenderFns } from "./signAture.vue?vue&type=template&id=74be91b8&scoped=true&"
import script from "./signAture.vue?vue&type=script&lang=js&"
export * from "./signAture.vue?vue&type=script&lang=js&"
import style0 from "./signAture.vue?vue&type=style&index=0&id=74be91b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be91b8",
  null
  
)

export default component.exports